import emotions from '../utils/emotions';

export function parseEmotionResponse(aiResponse) {
  try {
    let cleanedResponse = aiResponse.trim();
    
    // Extract JSON portion by finding first closing brace  
    const jsonEndIndex = cleanedResponse.indexOf('}') + 1;
    if (jsonEndIndex > 0) {
      cleanedResponse = cleanedResponse.substring(0, jsonEndIndex);
    }

    // If response starts with a number, prepend appropriate field
    if (/^\d+/.test(cleanedResponse)) {
      cleanedResponse = `{"confidence":${cleanedResponse}`;
    }

    // Wrap in braces if needed
    if (!cleanedResponse.startsWith('{')) {
      cleanedResponse = '{' + cleanedResponse;
    }

    const emotionData = JSON.parse(cleanedResponse);
    
    // Validate required fields
    const { confidence, id, name, description } = emotionData;
    if (!confidence || !id || !name || !description) {
      return null;
    }

    // Check confidence threshold
    if (confidence < 60) {
      return null;
    }

    // For local testing (development), bypass strict matching
    if (process.env.NODE_ENV === 'development') {
      return { ...emotionData };
    }

    // Validate emotion exists in our predefined list
    const validEmotion = emotions.find(emotion => 
      emotion.id === id && 
      emotion.name.toLowerCase() === name.toLowerCase() &&
      emotion.description.toLowerCase() === description.toLowerCase()
    );

    // Return validated emotion with confidence score
    return validEmotion ? { ...validEmotion, confidence } : null;
  } catch (error) {
    return null;
  }
}